import React, { Component } from 'react';
import moment from 'moment';

const formatNumber = {
    separador: ',', // separador para los miles
    sepDecimal: '.', // separador para los decimales

    formatear: function (num) {
        num += '';
        let splitStr = num.split('.');
        let splitLeft = splitStr[0];
        let splitRight = splitStr.length > 1 ? this.sepDecimal + splitStr[1] : '';
        let regx = /(\d+)(\d{3})/;
        while (regx.test(splitLeft)) {
            splitLeft = splitLeft.replace(regx, "$1" + this.separador + "$2");
        }
        return this.simbol + splitLeft + splitRight;
    },

    new: function (num, simbol) {
        this.simbol = simbol || '';
        if (typeof num == 'undefined') {
            num = 0;
        }
        if (isNaN(num)) {
            return num;
        }
        return this.formatear(Number(num).toFixed(2));
    },
};

const isCU = (NumAtCard = '') => {
    const result = String(NumAtCard)?.toUpperCase()?.includes('CU-');
    return result;
}

const renderTableBody = (headers, data, checkbox) => {
    let body = "";
    body = data.map((invoice, index) => {
        const isCUDocument = isCU(invoice?.NumAtCard);
        return (
            <tr key={index}>
                {headers[0].value && <td className="text-center">
                    <input
                        type="checkbox"
                        style={{ minWidth: '100%', width: '15px', height: '15px' }}
                        id={`CheckAll_${index}`}
                        disabled={isCUDocument}
                        checked={!isCUDocument && !!checkbox.data.get(index)}
                        onChange={() => !isCUDocument && checkbox.selectOne(index)}
                    />
                </td>}
                {headers[1].value && <td className="text-center">{invoice.ObjType ?? ''}</td>}
                {headers[2].value && <td className="text-center">
                    <strong>{invoice.DocNum}</strong>
                </td>}
                {/* No.Ref.de. cliente */}
                {headers[3].value && <td className="text-center" style={{ whiteSpace: 'nowrap' }}>
                    <strong>{invoice.NumAtCard}</strong>
                </td>}
                {headers[4].value && <td className="text-center">{invoice.CardCode ?? ''}</td>}
                {headers[5].value && <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{invoice.U_FMB_AUX_CARDNAME || invoice.CardName || ''}</td>}
                {headers[6].value && <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{!invoice.DocDate ? '' : moment(invoice.DocDate).utc().format('YYYY-MM-DD')}</td>}
                {headers[7].value && <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{!invoice.DocDueDate ? '' : moment(invoice.DocDueDate).utc().format('YYYY-MM-DD')}</td>}
                {headers[8].value && <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{`${invoice.DocCur} ${formatNumber.new(invoice.DocTotal)}`}</td>}
                {headers[9].value && <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{`${invoice.DocCur} ${formatNumber.new(invoice.DocTotal - invoice.PorVencer)}`}</td>}
                {headers[10].value && <td className="text-center" style={{ whiteSpace: 'nowrap' }}>{`${invoice.DocCur} ${formatNumber.new(invoice.PorVencer)}`}</td>}
                {headers[11].value && <td className="text-center" style={{ maxWidth: '300px' }}>{`${invoice.RelatedPayments ?? ''}`}</td>}
            </tr>
        )
    })
    return body;
};

const renderTable = (headers, data, checkbox, openDetails) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            {headers[0].value && <td className="dataTables-header-center">{headers[0].title}</td>}
            {headers[1].value && <td className="dataTables-header-center">{headers[1].title}</td>}
            {headers[2].value && <td className="dataTables-header-center">{headers[2].title}</td>}
            {headers[3].value && <td className="dataTables-header-center">{headers[3].title}</td>}
            {headers[4].value && <td className="dataTables-header-center">{headers[4].title}</td>}
            {headers[5].value && <td className="dataTables-header-center">{headers[5].title}</td>}
            {headers[6].value && <td className="dataTables-header-center">{headers[6].title}</td>}
            {headers[7].value && <td className="dataTables-header-center">{headers[7].title}</td>}
            {headers[8].value && <td className="dataTables-header-center">{headers[8].title}</td>}
            {headers[9].value && <td className="dataTables-header-center">{headers[9].title}</td>}
            {headers[10].value && <td className="dataTables-header-center">{headers[10].title}</td>}
            {headers[11].value && <td className="dataTables-header-center">{headers[11].title}</td>}
        </tr>;
    }

    body = renderTableBody(headers, data, checkbox, openDetails);

    let table = "";

    table = <table id="dataTableTimbra" className="display" style={{ width: '100%' }}>
        <thead className="table-header">
            {header}
        </thead>
        <tbody>
            {body}
        </tbody>
    </table>;

    return table;

};

export const renderCollect = (headers, data, checkbox) => {

    return renderTable(headers, data, checkbox);

}